import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Row, Col, Label, Form } from "reactstrap";
import { Button, Modal, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import BreadCrumbs from "../../../../components/BreadCrumbs";
import EditPhotoUpload from "../../../../components/EditPhotoUpload";
import ControlledRowTextField from "../../../../components/ControlledRowTextField";
import ControlledSelect from "../../../../components/ControlledSelect";
import ButtonComponent from "../../../../components/ButtonComponent";

import { uploadImage } from "../../../../components/imageUploadCompont";
import {
    useGetPromotionDetailsByIdMutation,
    useUpdatePromotionMutation,
    useUpdatePromotionImageMutation,
    useUploadPromotionLogoFileExtntionHttpsMutation,
    useLazyGetPromotionTypeListQuery,
} from "../../../../redux/services/promotionService";
import { useLazyGetRestaurantFilterTagsQuery } from "../../../../redux/services/menuItemService";
import { MenuTypeForMenu } from '../../../../constants/constans';
import { MenuItem } from "../../../Menus/MenuList/MenusTable";
import { customFilterOption } from "../../../../utility/Utility";
import Swal from "sweetalert2";
import LoadingMessage from "../../../../components/LoadingMessage";
import { ApplyTypes } from "../../../../constants/constans";
import { useNormalizedMenuItems } from "../../../../hooks/normalizesMenuItemHook";


interface ItemType {
    type: string;
    id: string;
}

interface PromotionFormData {
    title: string;
    description: string;
    type: string;
    subType: string;
    value: number;
    code: string;
    expiresAt: string;
    minimumBillTotal: number;
    pointsToRupeeConversionRate: number;
    rupeeToPointConversionRate: number;
    appliedTo: string;
    isPublic: boolean;
    items: ItemType[];
    filterTags: string[];
}

const UpdatePromotion = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const restaurantId = useSelector((state: any) => state.restaurant.selectedRestaurantDetails.id);
    const promotionId = location?.state?.promotion?.id;

    const [triggerPromotionData, { isLoading: isPromotionDataLoading }] = useGetPromotionDetailsByIdMutation();
    const [updatePromotion] = useUpdatePromotionMutation();
    const [triggerGetFilterTags, { data: filterTagsData }] = useLazyGetRestaurantFilterTagsQuery();
    const [getPromotionImageReference] = useUploadPromotionLogoFileExtntionHttpsMutation();
    const [updatePromotionImage] = useUpdatePromotionImageMutation();
    const [getPromotionTypes, { isLoading: isPromotionTypesLoading }] = useLazyGetPromotionTypeListQuery();

    const { control, handleSubmit, setValue } = useForm<PromotionFormData>();

    const [promotionDetails, setPromotionDetails] = useState<any>(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [showImageUpdateModal, setShowImageUpdateModal] = useState(false);
    const [isImageUpdateLoading, setIsImageUpdateLoading] = useState(false);
    const [uploadedImgDetails, setUploadedImgDetails] = useState({
        imgSrc: "",
        formData: null,
        fileExtension: "",
    });
    const [promotionTypes, setPromotionTypes] = useState<any[]>([]);
    const [selectedPromotionType, setSelectedPromotionType] = useState<any>();
    const [subPromotionTypes, setSubPromotionTypes] = useState<any[]>([]);
    const [selectedSubPromotionType, setSelectedSubPromotionType] = useState<any>(null);
    const [selectedAppliedType, setSelectedAppliedType] =
        useState<any>(null);
    const [promotionTypesData, setPromotionTypesData] = useState<any>(null);
    // const [isAppliedtoAllItems, setIsAppliedtoAllItems] = useState(false);
    const [isPublic, setIsPublic] = useState(false);
    const [selectedMenuTypeOption, setSelectedMenuTypeOption] = useState<{
        value: string;
        label: string;
    } | null>(null);
    const [itemError, setItemError] = useState<string | null>(null);
    const [selectedOption, setSelectedOption] = useState<MenuItem | null>(null);
    const [menuItemsOptionsForMenu, setMenuItemsOptionsForMenu] = useState([]);
    const [selectedItems, setSelectedItems] = useState<any[]>(
        promotionDetails?.promotion?.items || []
    );
    const [appliedType, setAppliedType] = useState<any[]>([]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [appliedTypesData, setAppliedTypesData] = useState<any>(null);
    const singleItemsList = useNormalizedMenuItems();
    const comboItemList = useSelector((state: any) => state.setMenu.setMenus);
    const customMenuItemList = useSelector((state: any) => state.customizeMenu.customizeMenu);
    useEffect(() => {
        if (!selectedMenuTypeOption) {
            setMenuItemsOptionsForMenu([]);
            return;
        }

        let sourceList: any = [];
        // Determine the source list based on the selected menu type
        switch (selectedMenuTypeOption.value) {
            case "All":
                sourceList = [...singleItemsList, ...comboItemList, ...customMenuItemList];
                break;
            case "Single":
                sourceList = singleItemsList;
                break;
            case "SetMenu":
                sourceList = comboItemList;
                break;
            case "CustomMenu":
                sourceList = customMenuItemList;
                break;
            default:
                sourceList = [];
        }

        const menuItems = sourceList.map((item: any) => {
            let itemType = "";

            if (selectedMenuTypeOption.value === "All") {
                if (singleItemsList.some((i: any) => i.id === item.id)) {
                    itemType = "MenuItem";
                } else if (comboItemList.some((i: any) => i.id === item.id)) {
                    itemType = "SetMenu";
                } else if (customMenuItemList.some((i: any) => i.id === item.id)) {
                    itemType = "CustomMenu";
                }
            } else if (selectedMenuTypeOption.value === "Single") {
                itemType = "MenuItem";
            } else if (selectedMenuTypeOption.value === "SetMenu") {
                itemType = "SetMenu";
            } else if (selectedMenuTypeOption.value === "CustomMenu") {
                itemType = "CustomMenu";
            }

            return {
                value: item.id,
                label: (
                    <div style={{ display: "flex", justifyContent: "left", gap: "5%" }}>
                        <img
                            src={Array.isArray(item.imageUrl) ? item.imageUrl[0] : item.imageUrl}
                            alt={item.displayName}
                            width="30px"
                            height="30px"
                        />
                        {item.displayName}
                    </div>
                ),
                displayName: item.displayName,
                price: item.price,
                itemId: item.id,
                itemType: itemType,
                imageUrl: Array.isArray(item.imageUrl) ? item.imageUrl[0] : item.imageUrl,
                allergenInformation: item.allergenInformation || [],
                foodAttributes: item.foodAttributes || [],
            };
        });

        setMenuItemsOptionsForMenu(menuItems);
    }, [selectedMenuTypeOption, singleItemsList, comboItemList, customMenuItemList]);

    useEffect(() => {
        if (restaurantId) {
            getPromotionTypes(restaurantId).then((res) => {
                setPromotionTypesData(res.data);
                const options = res.data.promotionTypeList.map((type: any) => ({
                    value: type.id,
                    label: type.displayName,
                }));
                setPromotionTypes(options);

                // Set up applied types from constants (since backend doesn't provide them)
                const appliedTypeOptions = ApplyTypes.map((type: any) => ({
                    value: type.value,
                    label: type.label,
                }));
                setAppliedType(appliedTypeOptions);
                setAppliedTypesData(appliedTypeOptions); // Use the mapped options, not the raw ApplyTypes
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [restaurantId]);

    useEffect(() => {
        if (!promotionId) {
            toast.error("Missing promotion ID");
            navigate("/configuration/promotions");
            return;
        }

        if (restaurantId) {
            triggerGetFilterTags(restaurantId);

            const fetchPromotion = async () => {
                try {
                    const res = await triggerPromotionData({ restaurantId, promotionId }).unwrap();
                    setPromotionDetails(res);
                } catch (error) {
                    console.error("Failed to fetch promotion details", error);
                    toast.error("Failed to load promotion data");
                }
            };

            fetchPromotion();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [restaurantId, promotionId]);

    // Update the getItemDetailsByTypeAndId function to include itemType
    const getItemDetailsByTypeAndId = (type: string, itemId: string): MenuItem | null => {
        let sourceList: any[] = [];
        let mappedItemType = "";

        // Map backend types to frontend lists and determine itemType
        switch (type) {
            case "MenuItem":
            case "menuItem":
            case "Single":
                sourceList = singleItemsList;
                mappedItemType = "MenuItem";
                break;
            case "SetMenu":
            case "setMenu":
                sourceList = comboItemList;
                mappedItemType = "SetMenu";
                break;
            case "CustomMenu":
            case "customMenu":
                sourceList = customMenuItemList;
                mappedItemType = "CustomMenu";
                break;
            default:
                console.warn("Unknown item type:", type, "for id:", itemId);
                return null;
        }

        const foundItem = sourceList.find((item: any) => item.id === itemId);

        if (foundItem) {
            // Return the item with the correct itemType and itemId
            return {
                ...foundItem,
                itemType: mappedItemType,
                itemId: foundItem.id || foundItem.itemId,
            };
        }

        return null;
    };

    // Update the useEffect that sets form values to properly handle appliedTo
    useEffect(() => {
        if (promotionDetails && appliedType.length > 0) { // Wait for appliedType to be loaded
            const promo = promotionDetails.promotion;
            setValue("title", promo.title || "");
            setValue("description", promo.description || "");
            setValue("value", promo.value || 0);
            setValue("code", promo.code || "");
            setValue("minimumBillTotal", promo.minimumBillTotal || 0);
            setValue("pointsToRupeeConversionRate", promo.pointsToRupeeConversionRate || 0);
            setValue("rupeeToPointConversionRate", promo.rupeeToPointConversionRate || 0);
            setValue("isPublic", promo.isPublic || false);
            setValue("expiresAt", promo.expiresAt || "");
            setValue("filterTags", (promo.filterTags || []).map((tag: string) => ({ value: tag, label: tag })));

            // Set appliedTo type from backend data
            if (promo.appliedTo) {

                const appliedTypeOption = appliedType.find((type: any) =>
                    type.value === promo.appliedTo || type.label === promo.appliedTo
                );

                if (appliedTypeOption) {
                    setSelectedAppliedType(appliedTypeOption);
                    setValue("appliedTo", appliedTypeOption.value);
                } else {
                    console.error("No matching appliedTo option found");
                }
            }

            // Set main promotion type
            if (promo.type) {
                const mainType = promotionTypes.find(type => type.label === promo.type);
                if (mainType) {
                    setSelectedPromotionType(mainType);

                    // Set sub promotion type if it exists
                    if (promo.subType && promotionTypesData?.promotionTypeList) {
                        const selectedTypeData = promotionTypesData.promotionTypeList.find(
                            (type: any) => type.id === mainType.value
                        );

                        if (selectedTypeData && selectedTypeData.subTypes) {
                            const formattedSubTypes = selectedTypeData.subTypes.map((subType: string) => ({
                                value: subType,
                                label: subType,
                            }));
                            setSubPromotionTypes(formattedSubTypes);

                            const subType = formattedSubTypes.find((sub: any) => sub.value === promo.subType);
                            if (subType) {
                                setSelectedSubPromotionType(subType);
                            }
                        }
                    }
                }
            }

            if (promo.items && Array.isArray(promo.items)) {

                const mappedItems: MenuItem[] = promo.items
                    .map((item: { itemId: string; type: string }) => {
                        const foundItem = getItemDetailsByTypeAndId(item.type, item.itemId);
                        return foundItem;
                    })
                    .filter((item: any): item is MenuItem => item !== null);

                setSelectedItems(mappedItems);
            }
            setIsPublic(promo.isPublic || false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [promotionDetails, setValue, promotionTypes, promotionTypesData, appliedType, singleItemsList, comboItemList, customMenuItemList]); // Add the item lists as dependencies

    const filterTagsOptions = useMemo(() => {
        if (!filterTagsData) return [];
        return Object.values(filterTagsData.filterTags).flatMap((group: any) =>
            group.tags.filter((tag: any) => tag.show).map((tag: any) => ({ value: tag.tag, label: tag.tag }))
        );
    }, [filterTagsData]);

    const handleEdit = () => setIsEditMode(!isEditMode);
    const handleUpdatePhoto = () => setShowImageUpdateModal(true);
    const handleCloseModal = () => setShowImageUpdateModal(false);
    const handlePromotionTypeChange = (option: any) => {
        setSelectedPromotionType(option);
        setSelectedSubPromotionType(null); // Clear sub type when main type changes

        if (option && promotionTypesData?.promotionTypeList) {
            // Find the selected promotion type in the data
            const selectedTypeData = promotionTypesData.promotionTypeList.find(
                (type: any) => type.id === option.value
            );

            if (selectedTypeData && selectedTypeData.subTypes) {
                // Format sub types for the dropdown
                const formattedSubTypes = selectedTypeData.subTypes.map((subType: string) => ({
                    value: subType,
                    label: subType,
                }));
                setSubPromotionTypes(formattedSubTypes);
            } else {
                setSubPromotionTypes([]);
            }
        } else {
            setSubPromotionTypes([]);
        }
    };

    const handleSubPromotionTypeChange = (option: any) => {
        setSelectedSubPromotionType(option);
    };

    const imageUploadCallback = (e: any) => {
        setUploadedImgDetails({
            imgSrc: e.imgSrc,
            formData: e.formData,
            fileExtension: e.fileExtension,
        });
    };

    const handlePromotionImageUpdate = async () => {
        setIsImageUpdateLoading(true);
        try {
            const imageRef = await uploadImage(getPromotionImageReference, {
                fileExtention: uploadedImgDetails.fileExtension,
                formData: uploadedImgDetails.formData,
            });
            const updateImageResponse = await updatePromotionImage({
                imgRef: imageRef,
                restaurantId,
                promotionId,
            });
            if ("data" in updateImageResponse) {
                toast.success("Image successfully updated");
                navigate("/configuration/promotions");
            } else {
                toast.error("Something went wrong while updating image");
            }
        } catch {
            toast.error("Failed to update image");
        } finally {
            setIsImageUpdateLoading(false);
        }
    };

    // Update the onSubmit function to include the correct appliedTo value
    const onSubmit = async (formData: PromotionFormData) => {
        setIsSaving(true);

        try {
            const updatePayload = {
                restaurantId,
                promotionId,
                title: formData.title,
                description: formData.description,
                type: selectedPromotionType?.label,
                subType: selectedSubPromotionType?.value,
                pointsToRupeeConversionRate:
                    selectedPromotionType?.label === "LoyaltyPoints" ? formData.pointsToRupeeConversionRate : undefined,
                rupeeToPointConversionRate:
                    selectedPromotionType?.label === "LoyaltyPoints" ? formData.rupeeToPointConversionRate : undefined,
                appliedTo: selectedAppliedType?.value, // Use the selected applied type value
                isPublic: formData.isPublic,
                minimumBillTotal: +formData.minimumBillTotal,
                value: +formData.value,
                code: formData.code,
                expiresAt: new Date(formData.expiresAt).toISOString(),
                items: (selectedAppliedType?.value === "Items" || selectedAppliedType?.value === "All")
                    ? selectedItems.map((item) => ({
                        itemId: item.id || item.itemId,
                        type: item.itemType,
                    }))
                    : [],
                filterTags: (selectedAppliedType?.value === "FilterTags" || selectedAppliedType?.value === "All")
                    ? formData.filterTags.map((tag: any) => tag.value)
                    : [],
            };

            await updatePromotion(updatePayload).unwrap();
            toast.success("Promotion updated successfully");
            navigate("/configuration/promotions");
        } catch (err) {
            console.error("Update failed:", err);
            toast.error("Failed to update promotion");
        } finally {
            setIsSaving(false);
        }
    };

    const handleMenuTypeChange = (
        option: { value: string; label: string } | null
    ) => {
        setSelectedMenuTypeOption(option);
        if (option) {
            setItemError(null);
        }
    };

    const handleItemChange = (option: MenuItem | null) => {
        setSelectedOption(option);
        if (option) {
            setItemError(null);
        }
    };

    const handleAdd = () => {
        if (selectedOption) {
            const isDuplicate = selectedItems.some(
                (item) => item.displayName === selectedOption.displayName
            );
            if (isDuplicate) {
                setItemError("This item is already added");
            } else {
                setSelectedItems([...selectedItems, selectedOption]);
                setSelectedOption(null);
                setItemError(null);
            }
        }
    };

    const handleDelete = (index: number) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                const updatedItems = [...selectedItems];
                updatedItems.splice(index, 1);
                setSelectedItems(updatedItems);

                Swal.fire("Deleted!", "Your item has been deleted.", "success");
            }
        });
    };

    // Add a handler function for Applied To changes
    const handleAppliedTypeChange = (option: any) => {
        setSelectedAppliedType(option);
        setValue("appliedTo", option?.value);
    };

    if (isPromotionTypesLoading || isPromotionDataLoading) {
        return <div className="bg-white">
            <h4 className='p-3 mt-3'>Update Promotion</h4>
            <LoadingMessage />
        </div>;
    }

    return (
        <>
            <BreadCrumbs hasSubMenus={true} />
            <Card className="py-2">
                <CardHeader className="d-flex justify-content-between bg-white">
                    <h4>Update Promotion</h4>
                    <Button variant="light" onClick={handleEdit}>
                        <FontAwesomeIcon icon={faEdit} title="Edit" color="#699BF7" />
                    </Button>
                </CardHeader>
                <CardBody>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        {promotionDetails?.promotion?.imageUrl && (
                            <Row className="mb-4">
                                <Col lg="4">
                                    <Label>Promotion Photo</Label>
                                </Col>
                                <Col lg="8">
                                    <img
                                        src={promotionDetails.promotion.imageUrl}
                                        alt="promotion"
                                        style={{ width: "30%", height: "auto", borderRadius: "30px" }}
                                    />
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        onClick={handleUpdatePhoto}
                                        style={{ position: "relative", top: "45%", right: "10%" }}
                                        title="Edit Photo"
                                        disabled={!isEditMode}
                                    >
                                        <FontAwesomeIcon icon={faEdit} />
                                    </Button>
                                </Col>
                            </Row>
                        )}
                        <Modal show={showImageUpdateModal} onHide={handleCloseModal} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Update Promotion Photo</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <EditPhotoUpload
                                    imageUrl={uploadedImgDetails.imgSrc}
                                    onUpload={imageUploadCallback}
                                />
                            </Modal.Body>
                            <Modal.Footer>
                                {isImageUpdateLoading ? (
                                    <ButtonComponent titel="Saving..." icon={<FontAwesomeIcon icon={faSpinner} spin />} isDisabled />
                                ) : (
                                    <ButtonComponent titel="Save" onClick={handlePromotionImageUpdate} />
                                )}
                            </Modal.Footer>
                        </Modal>
                        <hr />
                        <ControlledRowTextField label="Title" inputName="title" inputType="text" control={control} isDisabled={!isEditMode} />
                        <hr />
                        <ControlledRowTextField label="Description" inputName="description" inputType="text" control={control} isDisabled={!isEditMode} />
                        <hr />
                        <Row className="align-items-center mb-3">
                            <Col lg="4">
                                <Label className="pt-1 form-label">Promotion Type</Label>
                            </Col>
                            <Col lg="8">
                                <Select
                                    value={selectedPromotionType}
                                    onChange={handlePromotionTypeChange}
                                    options={promotionTypes}
                                    placeholder="Select Promotion Type"
                                    isSearchable
                                    isDisabled={!isEditMode}
                                />
                            </Col>
                        </Row>
                        {(selectedPromotionType?.label === "Cash" || selectedPromotionType?.label === "LoyaltyPoints") && (
                            <>
                                <hr />
                                <Row className="align-items-center mb-3">
                                    <Col lg="4">
                                        <Label className="pt-1 form-label">Sub Promotion Type</Label>
                                    </Col>
                                    <Col lg="8">
                                        <Select
                                            value={selectedSubPromotionType}
                                            onChange={handleSubPromotionTypeChange}
                                            options={subPromotionTypes}
                                            placeholder="Select Sub Promotion Type"
                                            isSearchable
                                            isDisabled={!selectedPromotionType || !isEditMode}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )}
                        <hr />
                        <ControlledRowTextField label="Value" inputName="value" inputType="number" control={control} isDisabled={!isEditMode} />
                        <hr />
                        <ControlledRowTextField label="Code" inputName="code" inputType="text" control={control} isDisabled={!isEditMode} />
                        <hr />
                        <ControlledRowTextField label="Minimum Bill Total" inputName="minimumBillTotal" inputType="number" control={control} isDisabled={!isEditMode} />
                        <hr />
                        {selectedPromotionType?.label === "LoyaltyPoints" && (
                            <>
                                <ControlledRowTextField
                                    label="Points to Rupee"
                                    inputName="pointsToRupeeConversionRate"
                                    inputType="number"
                                    control={control}
                                    isDisabled={!isEditMode}
                                />
                                <hr />
                                <ControlledRowTextField
                                    label="Rupee to Point"
                                    inputName="rupeeToPointConversionRate"
                                    inputType="number"
                                    control={control}
                                    isDisabled={!isEditMode}
                                />
                                <hr />
                            </>
                        )}
                        <Row className="mb-3">
                            <Col lg="4">
                                <Label>Expires At</Label>
                            </Col>
                            <Col lg="8">
                                <Controller
                                    control={control}
                                    name="expiresAt"
                                    render={({ field }) => (
                                        <Flatpickr
                                            {...field}
                                            className="form-control"
                                            options={{ dateFormat: "Y-m-d", minDate: new Date() }}
                                            onChange={(date: any) => field.onChange(date[0])}
                                        />
                                    )}
                                    disabled={!isEditMode}
                                />
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col lg="4">
                                <Label
                                    className="form-check-label"
                                    htmlFor="supportsPreOrdering"
                                >
                                    Is Public
                                </Label>
                            </Col>
                            <Col lg="8">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="isPublic"
                                    checked={isPublic}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        setIsPublic(event.target.checked);
                                        setValue("isPublic", event.target.checked);
                                    }}
                                />
                            </Col>
                        </Row>
                        <hr />
                        <Row className="align-items-center">
                            <Col lg="4">
                                <Label className="pt-1 form-label">Applied To</Label>
                            </Col>
                            <Col lg="8">
                                <Select
                                    value={selectedAppliedType}
                                    onChange={handleAppliedTypeChange} // Use the handler instead of direct setter
                                    options={appliedType} // Use appliedType instead of appliedTypesData
                                    placeholder="Select Applied To"
                                    isSearchable
                                    isDisabled={!isEditMode}
                                />
                            </Col>
                        </Row>
                        {(selectedAppliedType?.label === "FilterTags") && (
                            <>
                                <hr />
                                <ControlledSelect
                                    label={"Filter Tags"}
                                    inputName={"filterTags"}
                                    control={control}
                                    isMulti={true}
                                    optionsList={filterTagsOptions}
                                />
                            </>
                        )}
                        {(selectedAppliedType?.label === "FilterTags" || selectedAppliedType?.label === "All"
                        ) && (
                                <div className="d-flex justify-content-end mt-4 mb-2">
                                    {isSaving ? (
                                        <ButtonComponent
                                            icon={<FontAwesomeIcon icon={faSpinner} spin />}
                                            type="submit"
                                            titel="Saving..."
                                            isDisabled={true}
                                        />
                                    ) : (
                                        <ButtonComponent
                                            type="submit"
                                            titel="Save"
                                            onClick={handleSubmit(onSubmit)}
                                        />
                                    )}
                                </div>
                            )}
                    </Form>
                </CardBody>
            </Card>
            {(selectedAppliedType?.label === "Items") && (
                <Card className="mt-3">
                    <CardBody className="mt-3">
                        <div className="selected-items-container">
                            <Row className="align-items-center">
                                <Col sm={4}>
                                    <Label className="pt-1 form-label">Menu Items</Label>
                                </Col>
                                <Col sm={2}>
                                    <Select
                                        value={selectedMenuTypeOption}
                                        onChange={handleMenuTypeChange}
                                        options={MenuTypeForMenu}
                                        placeholder="Menu Type"
                                        isSearchable
                                        isDisabled={!isEditMode}
                                    />
                                </Col>
                                <Col sm={4}>
                                    <Select
                                        value={selectedOption}
                                        onChange={handleItemChange}
                                        options={menuItemsOptionsForMenu}
                                        // placeholder={isLoading ? "Loading..." : "Search menu item"}
                                        placeholder={"Search menu item"}
                                        isSearchable
                                        isDisabled={!selectedMenuTypeOption || !isEditMode}
                                        loadingMessage={() => "Loading menu items..."}
                                        // noOptionsMessage={() =>
                                        //     isLoading ? "Loading..." : "No items found"
                                        // }
                                        noOptionsMessage={() =>
                                            "No items found"
                                        }
                                        filterOption={customFilterOption}
                                    />
                                </Col>
                                <Col sm={2} className="text-right">
                                    <ButtonComponent
                                        titel="+Add Item"
                                        type="button"
                                        onClick={handleAdd}
                                        isDisabled={
                                            !selectedMenuTypeOption || !selectedOption || !isEditMode
                                        }
                                    />
                                </Col>
                            </Row>
                            {itemError && (
                                <Row className="mt-2">
                                    <Col>
                                        <div className="text-danger">{itemError}</div>
                                    </Col>
                                </Row>
                            )}
                            <hr />
                            <h5>Selected Items</h5>
                            <Table bordered className="mt-3" responsive>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Price (Rs.)</th>
                                        {/* <th>Food Attributes</th>
                                        <th>Allergen Information</th> */}
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="d-flex gap-3">{item.displayName}</div>
                                                {/* <span className='text-warning' style={{ fontSize: '0.875rem' }}>
                                                    {item.type === 'setMenu' ? 'Combo' : item.type === 'menuItem' ? 'Menu Item' : 'Customize'}
                                                </span> */}
                                            </td>
                                            <td>{item.price.toFixed(2)}</td>
                                            {/* <td>
                                                <div className="d-flex gap-2">
                                                    {item.foodAttributes?.length ? (
                                                        item.foodAttributes.map(
                                                            (attribute: any, i: any) => (
                                                                <img
                                                                    key={i}
                                                                    src={getImageUrl(attribute)}
                                                                    alt={attribute}
                                                                    width="24"
                                                                    height="24"
                                                                    title={attribute}
                                                                />
                                                            )
                                                        )
                                                    ) : (
                                                        <span className='text-secondary sm'>No</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex gap-2">
                                                    {item.allergenInformation?.length ? (
                                                        item.allergenInformation.map(
                                                            (attribute: any, i: any) => (
                                                                <img
                                                                    key={i}
                                                                    src={getImageUrl(attribute)}
                                                                    alt={attribute}
                                                                    width="24"
                                                                    height="24"
                                                                    title={attribute}
                                                                />
                                                            )
                                                        )
                                                    ) : (
                                                        <span className='text-secondary sm'>No</span>
                                                    )}
                                                </div>
                                            </td> */}
                                            <td>
                                                <Button
                                                    variant="light"
                                                    type="button"
                                                    onClick={() => handleDelete(index)}
                                                    disabled={!isEditMode}
                                                >
                                                    <FontAwesomeIcon icon={faTrash} color="#F24E1E" />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-4 mb-2">
                                {isSaving ? (
                                    <ButtonComponent
                                        icon={<FontAwesomeIcon icon={faSpinner} spin />}
                                        type="submit"
                                        titel="Saving..."
                                        isDisabled={true}
                                    />
                                ) : (
                                    <ButtonComponent
                                        type="submit"
                                        titel="Save"
                                        onClick={handleSubmit(onSubmit)}
                                        isDisabled={!isEditMode}
                                    />
                                )}
                            </div>
                        </div>
                    </CardBody>
                </Card>)}
        </>
    );
};

export default UpdatePromotion;